import apiConfigs from "../configs/api.configs";
import axios from 'axios'

export default {
    methods: {
        getLogin(username,password,token) {
            return fetch(`${apiConfigs.apiUrlConnect}${apiConfigs.apiKey}`,{
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    username:username,
                    password:password,
                    request_token:token
                })
              
            })
            .then(res => res.json())
        },
        getToken(){
            return fetch(`${apiConfigs.apiUrlToken}${apiConfigs.apiKey}`)
                .then(res => res.json()).then(res=> {
                    localStorage.setItem('userSettings', JSON.stringify({request_token : res.request_token}));
                    return res.request_token
                })
        },
        getAuthorize(token){
            return fetch(`https://www.themoviedb.org/authenticate/${token}`).then(res=>res.json())
        },
        getDetails(token){
           return  this.getSession(token).then(res=>{
                return fetch(`${apiConfigs.apiUrlDetail}${apiConfigs.apiKey}&session_id=${res}`).then(res=>res.json())
            })
        },
        getSession(token){
            return fetch(`${apiConfigs.apiUrlSession}${apiConfigs.apiKey}`,{
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    request_token:token
                })
            })
                .then(res => res.json()).then(res=>{
                    localStorage.setItem('userSettings', JSON.stringify({request_token :token,session_id:res.session_id}));
        
                    return res.session_id
                
                })
        },
        logoutSession(session_id){
            return fetch(`${apiConfigs.apiUrlLogout}${apiConfigs.apiKey}`,{
                method: "DELETE",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    session_id:session_id
                })
            })
                .then(res => res.json()).then(res=> {
                    localStorage.removeItem('shopCart');
                })
        }
       
    }
}